export const KEY = 'giftCard'
export const PRODUCT_TYPE = 'amgiftcard'
export const PAGE_PATH = '/presentkort'
export const MEDIA_PATH = '/media/'
export const MEDIA_RESIZE_ACTION = 'resize'
export const TOTAL_SEGMENT_CODE = 'amgiftcard'
export const TOTAL_SEGMENT_SEPARATOR = ', '
export const OPTIONS_KEY = 'am_giftcard_options'
export const CARD_TYPE_VIRTUAL = 1
export const MESSAGE_MAX_LENGTH = 200
export const NAME_MAX_LENGTH = 100
export const EMAIL_MAX_LENGTH = 254
export const CODE_MAX_LENGTH = 64
export const FREE_PAYMENT_METHOD = 'free'
export const FREE_CHECKOUT_ROUTE = 'checkout'
export const FULLY_COVERED_GETTER = 'giftCard/isFullyCovered'
export const IMAGE_WIDTH = 680
export const IMAGE_HEIGHT = 460
export const GRAND_TOTAL_SEGMENT_CODE = 'grand_total'
export const ERROR_NOTIFICATION_TYPE = 'error'
export const AMOUNTS_FIELD = 'am_giftcard_amounts'
export const IMAGES_FIELD = 'am_giftcard_images'
export const OPEN_AMOUNT_ALLOWED_FIELD = 'am_allow_open_amount'
export const OPEN_AMOUNT_MIN_FIELD = 'am_open_amount_min'
export const OPEN_AMOUNT_MAX_FIELD = 'am_open_amount_max'

export const OPTION_FIELDS = {
  amount: 'am_giftcard_amount',
  customAmount: 'am_giftcard_amount_custom',
  type: 'am_giftcard_type',
  image: 'am_giftcard_image',
  senderName: 'am_giftcard_sender_name',
  recipientName: 'am_giftcard_recipient_name',
  recipientEmail: 'am_giftcard_recipient_email',
  message: 'am_giftcard_message'
}
